





















































































































































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  InvoiceRoutingLineItem,
  InvoiceRoutingInvoiceModel,
  InvoiceRoutingViewModel,
} from "./models";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import InvoiceRoutingInvoice from "./InvoiceRoutingInvoice.vue";
import {
  FinancialDocumentTypesEnum,
  PaymentMeansEnum,
} from "@/shared/models/enums.type";
import { AgencyWorkModelsEnum } from "@/shared/models/agencyWorkModel";
import { FinancialSettingsType } from "@/store/modules/financial";
import { TaxRateView } from "@/shared/models/taxRates";
import { UnitOfMeasureView } from "@/shared/models/unitOfMeasure";
import {
  calculateLineItem,
  fillInvoiceEditingTaxExemptionReason,
} from "../FinancialDocumentFormParts/functions";
import { BusinessUnit } from "@/shared/models/businessUnit";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import { Notification } from "@/store/modules/notifications";
import {
  FinDocLineItemViewModel,
  FinDocViewModel,
} from "../FinancialDocumentFormParts/models";
import * as _ from "lodash";

@Component({
  components: {
    LoadingOverlay,
    InvoiceRoutingInvoice,
  },
})
export default class InvoiceRoutingModal extends Vue {
  @PropSync("open") isOpen?: boolean;
  @Prop() originDocumentTypeId?: FinancialDocumentTypesEnum;
  @Prop() isForCancellation?: boolean;

  @Prop() defaultCustomerId?: number;
  @Prop() defaultName?: string;
  @Prop() defaultOib?: any;
  @Prop() defaultPaymentMeansId?: number;
  @Prop() defaultCardTypeId?: number | null;
  @Prop() reservationId?: number;

  financialDocumentTypesEnum = FinancialDocumentTypesEnum;

  loading = false;

  allItems: InvoiceRoutingLineItem[] = [];
  invoices: InvoiceRoutingInvoiceModel[] = [];

  get unassignedItems() {
    return this.allItems.filter((e) => !e.isAssigned);
  }

  @Watch("isOpen")
  openWatch(fresh: boolean) {
    if (!fresh) {
      this.invoices = [];
      this.allItems = [];
      this.loading = false;
      return;
    }

    const newInvoice = new InvoiceRoutingInvoiceModel();
    newInvoice.documentTypeId =
      this.originDocumentTypeId ?? FinancialDocumentTypesEnum.Racun;
    this.fillInvoiceDefaults(newInvoice);
    this.invoices.push(newInvoice);

    this.loadItems();
  }

  loadItems() {
    let routingType = "";
    if (
      this.originDocumentTypeId === FinancialDocumentTypesEnum.RacunZaPredujam
    )
      routingType = "PrepaymentInvoice";
    if (this.originDocumentTypeId === FinancialDocumentTypesEnum.Otpremnica)
      routingType = "DeliveryNote";
    if (
      this.originDocumentTypeId === FinancialDocumentTypesEnum.Racun &&
      !this.isForCancellation
    )
      routingType = "Invoice";
    if (
      this.originDocumentTypeId === FinancialDocumentTypesEnum.Racun &&
      this.isForCancellation
    )
      routingType = "CancellationInvoice";

    this.loading = true;
    Vue.axios
      .get<InvoiceRoutingViewModel>(
        "financialDocuments/GetInvoiceRoutingItems",
        {
          params: {
            reservationId: this.reservationId,
            culture: this.internalLanguage,
            routingType: routingType,
          },
        }
      )
      .then((res) => {
        if (res.data.warnings && res.data.warnings.length > 0) {
          res.data.warnings.forEach((e) => {
            this.$store.dispatch("showNotification", {
              color: "warning",
              message: e,
              timeout: 10000,
              localize: true,
              actions: [
                {
                  text: this.$t("Continue"),
                  fun: () => {
                    return true;
                  },
                },
                {
                  text: this.$t("Cancel"),
                  fun: () => {
                    this.close();
                    return true;
                  },
                },
              ],
            } as Notification);
          });
        }

        const items = res.data.items;
        items.forEach((e) =>
          calculateLineItem(
            e.lineItem,
            this.taxRates ?? [],
            this.workingToFormalConversionRate
          )
        );

        this.allItems = items.map((e) => {
          return {
            ...e.lineItem,
            propertyId: e.propertyId,
            vatCategoryForPrepaymentsId: e.vatCategoryForPrepaymentsId,
            isSelected: false,
            isAssigned: false,
            originalTaxRateId: e.lineItem.taxRateId,
            businessUnitId: e.businessUnitId,
          };
        });
      })
      .finally(() => (this.loading = false));
  }

  close() {
    this.isOpen = false;
  }

  removeInvoice(invoice: InvoiceRoutingInvoiceModel) {
    for (const item of invoice.items) {
      this.removeItem(invoice, item);

      if (
        invoice.documentTypeId === FinancialDocumentTypesEnum.RacunZaPredujam
      ) {
        item.taxRateId = item.originalTaxRateId;
      }
    }

    this.invoices = this.invoices.filter((x) => x != invoice);
  }

  removeItem(
    invoice: InvoiceRoutingInvoiceModel,
    item: InvoiceRoutingLineItem
  ) {
    invoice.items = invoice.items.filter((x) => x != item);
    item.isSelected = false;
    item.isAssigned = false;

    if (invoice.documentTypeId === FinancialDocumentTypesEnum.RacunZaPredujam) {
      this.setTaxRatesForPrepaymentInvoice(invoice);
    }
  }

  addItems(invoice: InvoiceRoutingInvoiceModel) {
    this.dragIn(invoice);
    this.dropped();
  }

  addInvoiceOrDeliveryNote(type: FinancialDocumentTypesEnum) {
    const invoice = new InvoiceRoutingInvoiceModel();
    invoice.documentTypeId = type;
    this.fillInvoiceDefaults(invoice);
    this.invoices.push(invoice);

    const selected =
      this.allItems?.filter((x) => x.isSelected && !x.isAssigned) ?? [];
    if (selected.length > 0) {
      invoice.items.push(...selected);
      invoice.items.sort((a, b) =>
        a.propertyId != b.propertyId
          ? (a.propertyId ?? 0) - (b.propertyId ?? 0)
          : (a.addOnServiceId ?? 0) - (b.addOnServiceId ?? 0)
      );
    }

    if (this.allItems)
      for (const item of this.allItems.filter((x) => x.isSelected))
        item.isAssigned = true;
  }

  fillInvoiceDefaults(invoice: InvoiceRoutingInvoiceModel) {
    invoice.customerId = this.defaultCustomerId ?? null;
    invoice.customerName = this.defaultName ?? "";
    invoice.customerOib = this.defaultOib;
    invoice.paymentMeansId =
      invoice.documentTypeId === FinancialDocumentTypesEnum.Otpremnica
        ? PaymentMeansEnum.TransakcijskiRacun
        : this.defaultPaymentMeansId ??
          this.storedSettings?.paymentMeansId ??
          null;
    invoice.cardTypeId = this.defaultCardTypeId ?? null;
  }

  // drag&drop
  setDrag(e: DragEvent, data: InvoiceRoutingLineItem) {
    if (!data.isSelected) {
      this.allItems
        ?.filter((x) => !x.isAssigned)
        .forEach((x) => (x.isSelected = false));
      data.isSelected = true;
    }

    if (e.dataTransfer) {
      e.dataTransfer.clearData();
      e.dataTransfer.setData("application/json+lineitem", JSON.stringify(data));
    }
  }
  dragIn(invoice: InvoiceRoutingInvoiceModel) {
    const selected =
      this.allItems.filter((x) => x.isSelected && !x.isAssigned) ?? [];
    if (selected.length > 0) {
      invoice.items.push(...selected);
      invoice.items.sort((a, b) =>
        a.propertyId != b.propertyId
          ? (a.propertyId ?? 0) - (b.propertyId ?? 0)
          : (a.addOnServiceId ?? 0) - (b.addOnServiceId ?? 0)
      );

      if (
        invoice.documentTypeId === FinancialDocumentTypesEnum.RacunZaPredujam
      ) {
        this.setTaxRatesForPrepaymentInvoice(invoice);
      }
    }
  }
  dragOut(invoice: InvoiceRoutingInvoiceModel) {
    const removedItems = invoice.items.filter((x) => !x.isAssigned);
    invoice.items = invoice.items.filter((x) => x.isAssigned);

    if (invoice.documentTypeId === FinancialDocumentTypesEnum.RacunZaPredujam) {
      removedItems.forEach((x) => (x.taxRateId = x.originalTaxRateId));
    }
  }
  dropped() {
    if (this.allItems)
      for (const item of this.allItems.filter((x) => x.isSelected))
        item.isAssigned = true;
  }

  setTaxRatesForPrepaymentInvoice(invoice: InvoiceRoutingInvoiceModel) {
    if (
      invoice.items.every(
        (x) =>
          x.agencyWorkModelId === AgencyWorkModelsEnum.OwnNameAndOtherInvoice
      ) &&
      invoice.items.some(
        (x) =>
          x.originalTaxRateId ===
          this.storedSettings?.downpaymentItemsDefaultTaxRate.id
      )
    ) {
      invoice.items.forEach((x) => {
        if (this.storedSettings) {
          x.taxRateId = this.storedSettings.downpaymentItemsDefaultTaxRate.id;
        }
      });
    } else if (
      invoice.items.every(
        (x) =>
          x.agencyWorkModelId === AgencyWorkModelsEnum.OwnNameAndOtherInvoice
      )
    ) {
      invoice.items.forEach((x) => {
        if (this.storedSettings) {
          x.taxRateId = x.originalTaxRateId;
        }
      });
    }
  }

  isFormValid = false;

  get disableSubmit() {
    const anyErrors = this.invoices.flatMap((e) => e.errors).length > 0;
    return !this.isFormValid || anyErrors;
  }

  submit() {
    if (!this.activeBusinessUnit || !this.activeCashRegister) return;

    const request = {
      culture: this.internalLanguage,
      reservationId: this.reservationId,
      businessUnitId: this.activeBusinessUnit.id,
      cashRegisterId: this.activeCashRegister.id,
      invoices: this.invoices.map((e) => {
        return {
          customerId: e.customerId,
          paymentMeansId: e.paymentMeansId,
          cardTypeId: e.cardTypeId,
          documentTypeId: e.documentTypeId,
          // fake basic info just to generate tax exemption reasons
          basicInfo: {
            showOwnerDetails: true,
          },
          businessUnitid: e.items.find((li) => !!li.businessUnitId)
            ?.businessUnitId,
          lineItems: e.items.map((li) => {
            return {
              itemName: li.itemName,
              reservationAccUnitTypeId: li.reservationAccUnitTypeId,
              resAccUnitTypeAddOnServiceId: li.resAccUnitTypeAddOnServiceId,
              addOnServiceId: li.addOnServiceId,
              unitOfMeasureId: li.unitOfMeasureId,
              decimalQuantity: li.decimalQuantity,
              taxRateId: li.taxRateId,
              consumptionTaxRate: li.consumptionTaxRate,
              grossUnitPrice: li.grossUnitPrice,
              discountPercent: li.discountPercent,

              taxExemptionReasonFromAOS: li.taxExemptionReasonFromAOS,
              isGroupedStayLineItem: li.isGroupedStayLineItem,

              isCityTax: li.isCityTax,
              isStayCancellation: li.isStayCancellation,

              ownerId: li.ownerId,
              ownerIsLegalEntity: li.ownerIsLegalEntity,
              ownerPaysVAT: li.ownerPaysVAT,
              ownerIsResident: li.ownerIsResident,
              ownerVatId: li.ownerVatId,
              agencyWorkModelId: li.agencyWorkModelId,
            } as FinDocLineItemViewModel;
          }),
          taxExemptionReason: "",
        };
      }),
      overrideRules: ["FinancialDocument.Validation.MustHaveTaxExemptionReason"]
    };

    // figure out tax exemption reasons
    request.invoices.forEach((e) => {
      fillInvoiceEditingTaxExemptionReason(
        e as any as FinDocViewModel,
        this.isForCancellation ?? false,
        this.paysVat
      );
    });

    this.loading = true;

    Vue.axios
      .post("financialDocuments/CreateInvoiceRoutingDocuments", request)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("FinancialDocument.SaveSuccess"),
          timeout: 5000,
        });
        this.close();
        this.$emit("saved");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getUnitOfMeasureName(id: number) {
    const unit = this.unitsOfMeasure?.find((e) => e.id === id);
    if (unit) return this.$t(unit.textResourceKey).toString();
    return "";
  }

  getTaxRateName(id: number) {
    const taxRate = this.taxRates?.find((e) => e.id === id);
    if (taxRate) return taxRate.name;
    return "";
  }

  reset() {
    this.invoices = [];
    this.allItems.forEach((e) => {
      e.isSelected = false;
      e.isAssigned = false;
      e.taxRateId = e.originalTaxRateId;
    });
  }

  separateByUnit() {
    this.reset();

    const groupedByUnit = _.groupBy(
      this.allItems,
      (e) => e.reservationAccUnitTypeId
    );
    for (const key in groupedByUnit) {
      const group = groupedByUnit[key];

      const newInvoice = new InvoiceRoutingInvoiceModel();
      newInvoice.documentTypeId =
        this.originDocumentTypeId ?? FinancialDocumentTypesEnum.Racun;
      this.fillInvoiceDefaults(newInvoice);

      group.forEach((e) => (e.isSelected = true));
      this.addItems(newInvoice);

      this.invoices.push(newInvoice);
    }
  }

  separateByType() {
    this.reset();

    const groupedByType = _.groupBy(
      this.allItems,
      (e) => `${e.reservationAccUnitTypeId}_${e.isCityTax || !e.addOnServiceId}`
    );
    for (const key in groupedByType) {
      const group = groupedByType[key];

      const newInvoice = new InvoiceRoutingInvoiceModel();
      newInvoice.documentTypeId =
        this.originDocumentTypeId ?? FinancialDocumentTypesEnum.Racun;
      this.fillInvoiceDefaults(newInvoice);

      group.forEach((e) => (e.isSelected = true));
      this.addItems(newInvoice);

      this.invoices.push(newInvoice);
    }
  }

  get workingToFormalConversionRate() {
    return this.storedSettings?.workingToFormalConversionRate ?? 1;
  }

  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];
  @Getter("codebooks/unitsOfMeasure") unitsOfMeasure?: UnitOfMeasureView[];

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;

  @Getter("appParams/tenantGeneratesDeliveryNotes")
  tenantGeneratesDeliveryNotes?: boolean;

  @Getter("appParams/tenantPaysVat") tenantPaysVat?: boolean;
  get paysVat() {
    return this.tenantPaysVat ?? false;
  }

  @Getter("language/language") language?: string;
  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;
  @Getter("cashRegister/activeCashRegister")
  activeCashRegister?: CashRegisterModel;
}
